module.exports = __webpack_public_path__ + "img/购票天气日历@2x.c5941c59.png";